import { render, staticRenderFns } from "./StaffVacationRequestButton.vue?vue&type=template&id=ba0aff4c&scoped=true"
import script from "./StaffVacationRequestButton.vue?vue&type=script&lang=js"
export * from "./StaffVacationRequestButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba0aff4c",
  null
  
)

export default component.exports